export interface IPopupData {
    titleLocalizationKey: string | undefined;
    isContentHtmlType: boolean;
    contentMessage: string | undefined;
    isContentEditable?: boolean;
}
